import React, { useEffect, useState } from 'react';

import './NavigationBar.css';
import { useTranslation } from 'react-i18next';

import { Badge, Button, Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useHistory, withRouter } from 'react-router-dom';
import Loader from '../../components/Loader';
import i18n from '../../i18n';
import { getCompany, getUser, hasAdmin } from '../../helpers/jwt';

const logoImage = '/assets/img/mpoint_logo.png';
const navigationBarTitleValue = (
  <>
    {' '}
    <span className="d-none d-lg-inline mr-2 text-gray-600 small">
      {getUser()}
    </span>
    <i className="far fa-user-circle" style={{ fontSize: '22px' }} />{' '}
  </>
);

const NavigationBar = (props) => {
  const history = useHistory();
  const { t } = useTranslation();

  function handleLogout() {
    setLoader(true);
    localStorage.removeItem('user_jwt');
    props.history.push('/login');
  }

  // function changeLanguage(lang) {
  //     i18n.changeLanguage(lang);
  //     setCurrentLang(lang);
  //     localStorage.setItem("selectedLanguage", lang);
  // }
  //
  // useEffect(() => {
  //     const savedLang = localStorage.getItem("selectedLanguage");
  //     if (savedLang) {
  //         i18n.changeLanguage(savedLang);
  //         setCurrentLang(savedLang);
  //     }
  // }, []);




  // loader
  const [loader, setLoader] = useState(false);

  return (
    <>
      <Loader loader={loader} setLoader={setLoader} />
      <Navbar
        variant="light"
        fixed="top"
        bg="light"
        expand
        className="Navigation__wrapper  mb-4 pb-3 topbar "
      >
        <Container fluid>
          <Navbar as="ul" className="navbar-nav center-nav">
            <Nav>
              {!hasAdmin() && (
                <Nav.Item className="ml-4">
                  <Button
                    variant={'primary'}
                    active
                    onClick={() => history.push('/verification')}
                  >
                    <i className="fas fa-plus-circle mr-1" />

                    {t('administration.addVerification')}
                  </Button>
                </Nav.Item>
              )}
            </Nav>
          </Navbar>

          <Navbar as="ul" className="nav navbar-nav flex-nowrap ml-auto">
            <Badge variant={'primary'}>{getCompany()}</Badge>
            {/*<NavDropdown title={currentLang} id="language-dropdown">*/}
            {/*    <NavDropdown.Item onClick={() => changeLanguage("en")}>English</NavDropdown.Item>*/}
            {/*    <NavDropdown.Item onClick={() => changeLanguage("pl")}>Polski</NavDropdown.Item>*/}
            {/*</NavDropdown>*/}

            <div className="d-sm-block topbar-divider"></div>

            <Nav
              as="li"
              className="nav-item dropdown no-arrow"
              role="presentation"
            >
              <NavDropdown className="no-arrow" title={navigationBarTitleValue}>
                <NavDropdown.Item role="presentation" onClick={handleLogout}>
                  <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
                  &nbsp;{t('administration.logOut')}
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar>
        </Container>
      </Navbar>
    </>
  );
};

export default withRouter(NavigationBar);
